<template>
  <div class="ticket-manager">
    <h1>Support Ticket Manager</h1>

    <div class="tabs">
<button class="neutral" :class="{ active: selectedTab === 'open' }" @click="selectedTab = 'open'">Open Tickets</button>
<button class="neutral" :class="{ active: selectedTab === 'closed' }" @click="selectedTab = 'closed'">Closed Tickets</button>
  </div>

    <div class="ticket-list">
      <table v-if="tickets.length">
        <thead>
          <tr>
            <th>ID</th>
            <th>User</th>
            <th>Status</th>
            <th>Created</th>
            <th>Closed</th>
            <th>Closed By</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ticket in tickets" :key="ticket.id">
            <td>{{ ticket.id }}</td>
            <td>{{ ticket.username }}</td>
            <td>{{ ticket.status }}</td>
            <td>{{ formatTime(ticket.created_at) }}</td>
            <td>{{ ticket.closed_at || '—' }}</td>
            <td>{{ ticket.closed_by || '—' }}</td>
            <td>
             <button class="primary" @click="selectTicket(ticket)">View</button>

            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-controls" v-if="tickets.length">
 <button class="neutral" @click="prevPage" :disabled="currentPage === 1">Previous</button>
  <span>
  Page {{ selectedTab === 'open' ? currentPageOpen : currentPageClosed }}
  of {{ Math.ceil(totalTickets / perPage) }}
</span>

  <button class="neutral" @click="nextPage" :disabled="currentPage * perPage >= totalTickets">Next</button>
</div>

      <p v-if="!tickets.length">No {{ selectedTab }} tickets.</p>
    </div>

    <div v-if="selectedTicket" class="ticket-chat">
      <h2>Ticket #{{ selectedTicket.id }} - {{ selectedTicket.username }}</h2>
      <button class="neutral" @click="closePanel">Close Panel</button>

      <div class="chat-log" ref="chatLog">
        <div v-if="loadingChat">Loading chat...</div>
        <div v-else>
          <div
            v-for="msg in chatHistory"
            :key="msg.id"
            :class="['chat-msg', msg.role === 'admin' || msg.role === 'moderator' ? 'admin' : 'user']"
          >
            <div class="chat-bubble">
            <div class="chat-header">
  <span class="user-label">{{ msg.role === 'admin' || msg.role === 'moderator' ? 'Support' : msg.username }}</span>
  <span class="timestamp">{{ formatTime(msg.timestamp) }}</span>

  <!-- Delete option only if current user matches -->
  <button
    v-if="(msg.role === 'admin' || msg.role === 'moderator')"
    class="danger delete-btn"
    @click="deleteMessage(msg.id)"
    title="Delete message"
  >
    🗑️
  </button>
</div>

              <div class="chat-text">{{ msg.message }}</div>
            </div>
          </div>
        </div>
      </div>

      <form @submit.prevent="sendReply">
        <textarea v-model="newReply" placeholder="Reply to user..." required />
        <button class="primary" :disabled="isReplying">
  {{ isReplying ? 'Sending...' : 'Send Reply' }}
</button>

      </form>

      <div class="status-actions">
      <button v-if="selectedTicket.status === 'open'" class="danger" @click="closeTicket">Close Ticket</button>
<button v-else class="warning" @click="reopenTicket">Reopen Ticket</button>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SupportTicketManager',
  data() {
    return {
      refreshTimer: null,
chatRefreshTimer: null,
currentPageOpen: 1,
    currentPageClosed: 1,
    perPage: 20,
    totalTickets: 0,
      selectedTab: 'open',
      tickets: [],
      selectedTicket: null,
      chatHistory: [],
      loadingChat: false,
      newReply: '',
      isReplying: false,
    };
  },
mounted() {
  const ticketId = parseInt(this.$route?.params?.ticketId || this.$route?.query?.t);

  this.fetchTickets().then(() => {
    if (!ticketId) return;

    // Wait a moment for Vue reactivity to update `tickets`
    this.$nextTick(() => {
      const match = this.tickets.find(t => t.id === ticketId);
      if (match) {
        this.selectTicket(match);
      } else {
        this.tryFetchTicketById(ticketId);
      }
    });
  });

  this.startTicketAutoRefresh();
}
,



beforeUnmount() {
  this.stopTicketAutoRefresh();
  this.stopChatAutoRefresh();
},
watch: {
  selectedTab() {
    if (this.selectedTab === 'open' && this.currentPageOpen === 1) {
      this.fetchTickets();
    } else if (this.selectedTab === 'closed' && this.currentPageClosed === 1) {
      this.fetchTickets();
    } else {
      // Already on a non-1 page, still refresh
      this.fetchTickets();
    }

    this.selectedTicket = null;
    this.stopChatAutoRefresh();
    this.startTicketAutoRefresh();
  }
}
,
  methods: {
   tryFetchTicketById(ticketId) {
  axios.get(`/etherscan/fetch_ticket_by_id.php?ticket_id=${ticketId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(res => {
    if (res.data.status === 'success' && res.data.ticket) {
      this.selectedTab = res.data.ticket.status; // Set tab to 'open' or 'closed'
      this.selectTicket(res.data.ticket);
    }
  });
}
,

    deleteMessage(messageId) {
  if (!confirm('Are you sure you want to delete this message?')) return;

  axios.post('/etherscan/delete_ticket_message.php', {
    message_id: messageId
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(res => {
    if (res.data.status === 'success') {
      this.fetchChat(this.selectedTicket.id);
    }
  });
}
,
    startTicketAutoRefresh() {
  this.stopTicketAutoRefresh(); // Prevent duplicates
  this.refreshTimer = setInterval(() => {
    if (!this.selectedTicket) {
      this.fetchTickets();
    }
  }, 30000);
},
stopTicketAutoRefresh() {
  if (this.refreshTimer) {
    clearInterval(this.refreshTimer);
    this.refreshTimer = null;
  }
},
startChatAutoRefresh(ticketId) {
  this.stopChatAutoRefresh();
  this.chatRefreshTimer = setInterval(() => {
    if (this.selectedTicket && this.selectedTicket.id === ticketId) {
      this.fetchChat(ticketId);
    }
  }, 10000);
},
stopChatAutoRefresh() {
  if (this.chatRefreshTimer) {
    clearInterval(this.chatRefreshTimer);
    this.chatRefreshTimer = null;
  }
},

 fetchTickets() {
  const page = this.selectedTab === 'open' ? this.currentPageOpen : this.currentPageClosed;

  return axios.get(`/etherscan/fetch_support_tickets.php?status=${this.selectedTab}&page=${page}&per_page=${this.perPage}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(res => {
    if (res.data.status === 'success') {
      this.tickets = res.data.tickets;
      this.totalTickets = res.data.total;
    } else {
      this.tickets = [];
    }
  });
}

,
nextPage() {
  if (this.selectedTab === 'open') {
    if (this.currentPageOpen * this.perPage < this.totalTickets) {
      this.currentPageOpen++;
      this.fetchTickets();
    }
  } else {
    if (this.currentPageClosed * this.perPage < this.totalTickets) {
      this.currentPageClosed++;
      this.fetchTickets();
    }
  }
},
prevPage() {
  if (this.selectedTab === 'open') {
    if (this.currentPageOpen > 1) {
      this.currentPageOpen--;
      this.fetchTickets();
    }
  } else {
    if (this.currentPageClosed > 1) {
      this.currentPageClosed--;
      this.fetchTickets();
    }
  }
}
,
    selectTicket(ticket) {
  this.selectedTicket = ticket;
  this.fetchChat(ticket.id);
  this.startChatAutoRefresh(ticket.id);
  this.stopTicketAutoRefresh();

  this.$nextTick(() => {
  const chatLog = this.$refs.chatLog;
  if (chatLog) {
    chatLog.scrollTop = chatLog.scrollHeight;
  }
});

},

closePanel() {
  this.selectedTicket = null;
  this.chatHistory = [];
  this.stopChatAutoRefresh();
  this.startTicketAutoRefresh();
},

    fetchChat(ticketId) {
  this.loadingChat = true;
  const chatLog = this.$refs.chatLog;

  // Capture whether we're near the bottom before the update
  let wasNearBottom = false;
  if (chatLog) {
    const scrollDiff = chatLog.scrollHeight - chatLog.scrollTop - chatLog.clientHeight;
    wasNearBottom = scrollDiff < 50; // within 50px of bottom = "near"
  }

  axios.get(`/etherscan/fetch_ticket_messages.php?ticket_id=${ticketId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }).then(res => {
    if (res.data.status === 'success') {
      this.chatHistory = res.data.messages;

      this.$nextTick(() => {
        if (wasNearBottom && chatLog) {
          chatLog.scrollTop = chatLog.scrollHeight;
        }
      });
    }
  }).finally(() => {
    this.loadingChat = false;
  });
},

    sendReply() {
      if (!this.newReply.trim()) return;
      this.isReplying = true;
      axios.post('/etherscan/admin_reply_to_ticket.php', {
        ticket_id: this.selectedTicket.id,
        message: this.newReply
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(res => {
        if (res.data.status === 'success') {
          this.newReply = '';
          this.fetchChat(this.selectedTicket.id);
        }
      }).finally(() => {
        this.isReplying = false;
      });
    },
    closeTicket() {
      axios.post('/etherscan/close_ticket.php', {
        ticket_id: this.selectedTicket.id
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(() => this.fetchTickets());
    },
    reopenTicket() {
      axios.post('/etherscan/reopen_ticket.php', {
        ticket_id: this.selectedTicket.id
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(() => this.fetchTickets());
    },
    formatTime(iso) {
      return new Date(iso).toLocaleString();
    }
  }
};
</script>

<style scoped>
.ticket-manager {
  max-width: 1200px;
  margin: 0 auto;
}
.tabs button {
  margin-right: 12px;
  padding: 6px 12px;
}
.tabs .active {
  font-weight: bold;
  background-color: #e0e0e0;
}
.ticket-chat {
  margin-top: 20px;
  border-top: 1px solid #ccc;
  padding-top: 16px;
}
.chat-log {
  max-height: 300px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 12px;
  margin-bottom: 12px;
}
.chat-msg {
  margin-bottom: 10px;
}
.chat-bubble {
  padding: 10px;
  border-radius: 10px;
  background: #e0e0e0;
}
.chat-msg.admin .chat-bubble {
  background: #d4edda;
}
form textarea {
  width: 100%;
  height: 80px;
  margin-bottom: 10px;
}
.status-actions {
  margin-top: 12px;
}
/* Base button style */
button {
  padding: 8px 14px;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* General view / utility actions */
button:not(.primary):not(.danger):not(.neutral):not(.warning) {
  background-color: #f0f0f0;
  color: #333;
}
button:not(.primary):not(.danger):not(.neutral):not(.warning):hover {
  background-color: #ddd;
}

/* Primary actions (send reply, view ticket) */
button.primary {
  background-color: #4CAF50;
  color: white;
}
button.primary:hover {
  background-color: #45a049;
}

/* Danger actions (close ticket, delete msg) */
button.danger {
  background-color: #e53935;
  color: white;
}
button.danger:hover {
  background-color: #c62828;
}

/* Warning actions (reopen ticket) */
button.warning {
  background-color: #f57c00;
  color: white;
}
button.warning:hover {
  background-color: #ef6c00;
}

/* Neutral (pagination, tabs) */
button.neutral {
  background-color: #e0e0e0;
  color: #222;
}
button.neutral:hover {
  background-color: #d5d5d5;
}

/* Active tab */
.tabs .active {
  font-weight: bold;
  background-color: #c5e1a5;
}


</style>